/* eslint react/prop-types:0 */
/*
 * base-upload
 * author zhousheng
 */
import React, { Component } from 'react';
import AjaxUpload from './AjaxUploader';
function empty() { }
class Upload extends Component {
    constructor() {
        super(...arguments);
        this.saveUploader = (node) => {
            this.uploader = node;
        };
    }
    abort(file) {
        this.uploader.abort(file);
    }
    render() {
        return <AjaxUpload {...this.props} ref={this.saveUploader}/>;
    }
}
Upload.defaultProps = {
    component: 'span',
    prefixCls: 'rc-upload',
    data: {},
    headers: {},
    name: 'file',
    multipart: false,
    onStart: empty,
    onError: empty,
    onSuccess: empty,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
    openFileDialogOnClick: true
};
export default Upload;
